import braintree from 'braintree-web';

const initClient = clientToken => {
  return braintree.client.create({
    authorization: clientToken
  });
};
const initLocalPayment = client => braintree.localPayment.create({
  client
});
const initPaypal = client => braintree.paypal.create({
  client
});
const initThreeDSecure = client => braintree.threeDSecure.create({
  client,
  version: 2
});
const initDataCollector = function (client) {
  let paypal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  try {
    return braintree.dataCollector.create({
      client,
      paypal
    });
  } catch {
    return Promise.resolve(null);
  }
};
const tokenize = (hostedFields, options) => hostedFields.tokenize(options);
const initHostedFields = (client, fields, styles) => braintree.hostedFields.create({
  client,
  fields,
  styles
});

export { initClient, initDataCollector, initHostedFields, initLocalPayment, initPaypal, initThreeDSecure, tokenize };
//# sourceMappingURL=braintree.js.map
